<template>
  <div :id="'crt-' + cid + '-' + unitId" :size="size"></div>
</template>
<script>
import { defineComponent, onMounted, ref, nextTick, onBeforeUnmount } from '@nuxtjs/composition-api';
import { useDevice } from '@/composables/useDevice';
import { uniqueId } from 'lodash';
export default defineComponent({
  inheritAttrs: false,
  name: 'adblock',
  props: { cid: {}, size: {}, fixed: { type: Boolean, default: false }, className: { type: String, default: '' } },
  setup(props) {
    const { isMobile } = useDevice();
    const unitId = ref();

    const passBack = (containerid, zoneid, e) => {
      if (e.data && e.data === 'criteo-adblock-passback-' + zoneid) document.getElementById(containerid).style.display = 'none';
      else return false;
    };

    onMounted(() => {
      window.Criteo = window.Criteo || {};
      window.Criteo.events = window.Criteo.events || [];
      unitId.value = uniqueId('uid-');
      if (props.fixed) {
        if (window.innerWidth < 1440) {
          return;
        }
      }
      const CriteoAdblock = function (containerid, zoneid) {
        window.Criteo.events.push(function () {
          const abpSlot = document.getElementById(containerid);
          window.Criteo.DisplayAcceptableAdIfAdblocked({
            zoneid,
            containerid,
            overrideZoneFloor: false,
            callIfNotAdBlocked() {
              abpSlot.style.display = 'none';
            },
            callbacksuccess() {
              abpSlot.style.display = 'block';
              abpSlot.style.width = abpSlot.getAttribute('size').split('x')[0] + 'px';
              abpSlot.style.height = abpSlot.getAttribute('size').split('x')[1] + 'px';
              abpSlot.classList = props.className;
              document.querySelectorAll("div[id^='google_ads']").forEach((node) => (node.parentElement.style.display = 'none'));
              document.querySelectorAll('[unit-name]').forEach((node) => (node.style.display = 'none'));
              document.querySelector('#masthead-container').style.display = 'none';
            },
          });
          window.addEventListener('message', passBack.bind(this, containerid, zoneid), false);
        });
      };
      nextTick(() => {
        if (!isMobile.value) {
          CriteoAdblock('crt-' + props.cid + '-' + unitId.value, props.cid);
        }
      });
    });

    onBeforeUnmount(() => {
      removeEventListener('message', passBack);
    });
    return { unitId };
  },
});
</script>
